<template>
  <div v-if="currentUser.role == 'admin'" class="w-full bg-white border-b border-gray-200">

    <!-- Mobile header bar -->
    <div class="flex sm:hidden items-center justify-between px-4 h-14">
      <router-link :to="{ name: 'Home' }" class="flex-shrink-0">
        <img
          src="/kctLogo.webp"
          class="h-6" alt="KCT"
        />
      </router-link>
      <button @click="showMobileMenu = true"
        class="h-10 w-10 flex items-center justify-center text-gray-600 hover:text-gray-900">
        <i class="fa-solid fa-bars text-lg"></i>
      </button>
    </div>

    <!-- Mobile slide-out menu -->
    <transition name="slide">
      <div v-if="showMobileMenu" class="fixed inset-0 z-50 flex justify-end sm:hidden" style="z-index: 999999">
        <div class="absolute inset-0 bg-black bg-opacity-30" @click="showMobileMenu = false"></div>
        <div class="relative w-11/12 max-w-sm h-full bg-gray-900 text-white overflow-y-auto">
          <div class="flex items-center justify-between px-6 py-4">
            <span class="text-lg font-semibold">Menu</span>
            <button @click="showMobileMenu = false" class="h-10 w-10 flex items-center justify-center text-gray-400 hover:text-white">
              <i class="fa-solid fa-xmark text-xl"></i>
            </button>
          </div>

          <nav class="px-4 pb-6">
            <!-- Dashboard -->
            <div @click="mobileNavigate({ name: 'DashboardOverview' })"
              class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
              <i class="fa-solid fa-gauge-high text-primary mr-3 w-5 text-center"></i>
              Dashboard
            </div>

            <!-- CRM -->
            <div @click="mobileNavigate({ name: 'Crm' })"
              class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
              <i class="fa-solid fa-bolt text-primary mr-3 w-5 text-center"></i>
              CRM
            </div>

            <!-- Scheduling accordion -->
            <div class="w-full">
              <div @click="mobileSection = mobileSection === 'scheduling' ? null : 'scheduling'"
                class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
                <i class="fa-regular fa-clock text-primary mr-3 w-5 text-center"></i>
                Scheduling
                <i :class="mobileSection === 'scheduling' ? 'fa-chevron-down' : 'fa-chevron-right'" class="fa-solid ml-auto text-gray-400 text-xs"></i>
              </div>
              <div v-show="mobileSection === 'scheduling'" class="bg-gray-800 bg-opacity-50 rounded-lg mx-2 mb-2">
                <div @click="mobileNavigate({ name: 'Home' })" class="w-full flex items-center h-10 text-gray-300 text-sm hover:text-primary cursor-pointer px-8">
                  <i class="fa-regular fa-clock text-primary mr-3 w-4 text-center text-xs"></i>
                  Job Schedule
                </div>
                <div @click="mobileNavigate({ name: 'AiPlanner' })" class="w-full flex items-center h-10 text-gray-300 text-sm hover:text-primary cursor-pointer px-8">
                  <i class="fa-solid fa-wand-magic-sparkles text-primary mr-3 w-4 text-center text-xs"></i>
                  AI Planner
                </div>
                <div @click="mobileNavigate({ name: 'AiAssistant' })" class="w-full flex items-center h-10 text-gray-300 text-sm hover:text-primary cursor-pointer px-8">
                  <i class="fa-solid fa-robot text-primary mr-3 w-4 text-center text-xs"></i>
                  AI Assistant
                </div>
              </div>
            </div>

            <!-- Fleet accordion -->
            <div class="w-full">
              <div @click="mobileSection = mobileSection === 'fleet' ? null : 'fleet'"
                class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
                <i class="fa-solid fa-truck text-primary mr-3 w-5 text-center"></i>
                Fleet
                <i :class="mobileSection === 'fleet' ? 'fa-chevron-down' : 'fa-chevron-right'" class="fa-solid ml-auto text-gray-400 text-xs"></i>
              </div>
              <div v-show="mobileSection === 'fleet'" class="bg-gray-800 bg-opacity-50 rounded-lg mx-2 mb-2">
                <div @click="mobileNavigate({ name: 'Tracker' })" class="w-full flex items-center h-10 text-gray-300 text-sm hover:text-primary cursor-pointer px-8">
                  <i class="fa-solid fa-map-location-dot text-primary mr-3 w-4 text-center text-xs"></i>
                  Tracker
                </div>
                <div @click="mobileNavigate({ name: 'Fleet' })" class="w-full flex items-center h-10 text-gray-300 text-sm hover:text-primary cursor-pointer px-8">
                  <i class="fa-solid fa-truck text-primary mr-3 w-4 text-center text-xs"></i>
                  Fleet
                </div>
              </div>
            </div>

            <!-- Clients accordion -->
            <div class="w-full">
              <div @click="mobileSection = mobileSection === 'clients' ? null : 'clients'"
                class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
                <i class="fa-solid fa-user-group text-primary mr-3 w-5 text-center"></i>
                Clients
                <i :class="mobileSection === 'clients' ? 'fa-chevron-down' : 'fa-chevron-right'" class="fa-solid ml-auto text-gray-400 text-xs"></i>
              </div>
              <div v-show="mobileSection === 'clients'" class="bg-gray-800 bg-opacity-50 rounded-lg mx-2 mb-2">
                <div @click="mobileNavigate({ name: 'ClientBook' })" class="w-full flex items-center h-10 text-gray-300 text-sm hover:text-primary cursor-pointer px-8">
                  <i class="fa-solid fa-user-group text-primary mr-3 w-4 text-center text-xs"></i>
                  Client Book
                </div>
                <div @click="mobileNavigate({ name: 'CallLog' })" class="w-full flex items-center h-10 text-gray-300 text-sm hover:text-primary cursor-pointer px-8">
                  <i class="fa-solid fa-headset text-primary mr-3 w-4 text-center text-xs"></i>
                  Call Log
                </div>
              </div>
            </div>

            <!-- Users -->
            <div @click="mobileNavigate({ name: 'Users' })"
              class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
              <i class="fa-solid fa-user-shield text-primary mr-3 w-5 text-center"></i>
              Users
            </div>

            <!-- Tests -->
            <div @click="mobileNavigate({ name: 'Tests' })"
              class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
              <i class="fa-solid fa-flask-vial text-primary mr-3 w-5 text-center"></i>
              Tests
            </div>

            <!-- Settings -->
            <div @click="mobileNavigate({ name: 'SettingsSmsTemplates' })"
              class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg">
              <i class="fa-solid fa-gear text-primary mr-3 w-5 text-center"></i>
              Settings
            </div>

            <!-- Logout -->
            <div @click="logout()"
              class="w-full flex items-center h-12 text-white text-base hover:text-primary cursor-pointer px-4 rounded-lg mt-4 border-t border-gray-700 pt-4">
              <i class="fa-solid fa-right-from-bracket text-gray-400 mr-3 w-5 text-center"></i>
              Logout
            </div>
          </nav>
        </div>
      </div>
    </transition>

    <!-- Desktop nav bar -->
    <div class="w-full h-14 items-center hidden sm:flex px-6">
      <!-- Logo -->
      <router-link :to="{ name: 'Home' }" class="flex-shrink-0 mr-8">
        <img
          src="/kctLogo.webp"
          class="h-7" alt="KCT"
        />
      </router-link>

      <!-- Nav items -->
      <nav class="flex items-center h-full space-x-1">
        <router-link :to="{ name: 'DashboardOverview' }"
          class="nav-item" :class="isRouteGroup(['DashboardOverview', 'DashboardCustomers', 'DashboardMap', 'DashboardStaff']) ? 'nav-active' : 'nav-default'">
          Dashboard
        </router-link>

        <router-link :to="{ name: 'Crm' }"
          class="nav-item" :class="isRoute('Crm') ? 'nav-active' : 'nav-default'">
          CRM
        </router-link>

        <!-- Scheduling -->
        <div class="relative" @mouseenter="openDropdown = 'scheduling'" @mouseleave="openDropdown = null">
          <div class="nav-item cursor-pointer" :class="isRouteGroup(['Home', 'AiPlanner']) ? 'nav-active' : 'nav-default'">
            Scheduling
            <i class="fa-solid fa-chevron-down ml-1.5" style="font-size:9px;opacity:0.4"></i>
          </div>
          <div v-show="openDropdown === 'scheduling'" class="dropdown-menu">
            <div class="dropdown-menu-inner">
              <router-link :to="{ name: 'Home' }" class="dropdown-item">Job Schedule</router-link>
              <router-link :to="{ name: 'AiPlanner' }" class="dropdown-item">AI Planner</router-link>
            </div>
          </div>
        </div>

        <!-- Fleet -->
        <div class="relative" @mouseenter="openDropdown = 'fleet'" @mouseleave="openDropdown = null">
          <div class="nav-item cursor-pointer" :class="isRouteGroup(['Tracker', 'Fleet']) ? 'nav-active' : 'nav-default'">
            Fleet
            <i class="fa-solid fa-chevron-down ml-1.5" style="font-size:9px;opacity:0.4"></i>
          </div>
          <div v-show="openDropdown === 'fleet'" class="dropdown-menu">
            <div class="dropdown-menu-inner">
              <router-link :to="{ name: 'Tracker' }" class="dropdown-item">Tracker</router-link>
              <router-link :to="{ name: 'Fleet' }" class="dropdown-item">Fleet</router-link>
            </div>
          </div>
        </div>

        <!-- Clients -->
        <div class="relative" @mouseenter="openDropdown = 'clients'" @mouseleave="openDropdown = null">
          <div class="nav-item cursor-pointer" :class="isRouteGroup(['ClientBook', 'CallLog']) ? 'nav-active' : 'nav-default'">
            Clients
            <i class="fa-solid fa-chevron-down ml-1.5" style="font-size:9px;opacity:0.4"></i>
          </div>
          <div v-show="openDropdown === 'clients'" class="dropdown-menu">
            <div class="dropdown-menu-inner">
              <router-link :to="{ name: 'ClientBook' }" class="dropdown-item">Client Book</router-link>
              <router-link :to="{ name: 'CallLog' }" class="dropdown-item">Call Log</router-link>
            </div>
          </div>
        </div>

        <router-link :to="{ name: 'Users' }"
          class="nav-item" :class="isRoute('Users') ? 'nav-active' : 'nav-default'">
          Users
        </router-link>

        <router-link :to="{ name: 'Tests' }"
          class="nav-item" :class="isRoute('Tests') ? 'nav-active' : 'nav-default'">
          Tests
        </router-link>

      </nav>

      <!-- Right side -->
      <div class="ml-auto flex items-center space-x-2">
        <!-- AI Assistant -->
        <button @click="openAiAssistant()"
          class="h-8 px-3 rounded-md text-sm font-bold flex items-center bg-gray-900 text-white hover:bg-gray-700 transition-colors">
          Ask AI
        </button>

        <!-- Settings -->
        <router-link :to="{ name: 'SettingsSmsTemplates' }"
          class="h-8 w-8 rounded-md flex items-center justify-center text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors"
          title="Settings">
          <i class="fa-solid fa-gear text-sm"></i>
        </router-link>

        <!-- Notifications bell -->
        <div class="relative">
          <button @click="showNotifications = !showNotifications"
            class="h-8 w-8 rounded-md flex items-center justify-center text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors relative">
            <i class="fa-solid fa-bell text-sm"></i>
            <span v-if="unreadCount > 0"
              class="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-1">
              {{ unreadCount > 9 ? '9+' : unreadCount }}
            </span>
          </button>
          <!-- Notification dropdown -->
          <div v-if="showNotifications"
            class="fixed right-4 bg-white rounded-lg shadow-xl border border-gray-200 w-96 flex flex-col"
            style="z-index: 9999; top: 56px; max-height: 480px;">
            <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">
              <span class="font-semibold text-sm text-gray-800">Notifications</span>
              <div class="flex items-center gap-3">
                <span v-if="notifications.length > 0" @click="clearAllNotifications"
                  class="text-xs text-red-500 cursor-pointer hover:underline font-medium">Clear all</span>
              </div>
            </div>
            <!-- Tabs -->
            <div class="flex border-b border-gray-100 flex-shrink-0">
              <button @click="notifTab = 'active'"
                class="flex-1 text-xs font-medium py-2 text-center transition-colors"
                :class="notifTab === 'active' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'">
                Active <span v-if="activeNotifications.length" class="ml-1 bg-gray-100 text-gray-600 rounded-full px-1.5 py-0.5 text-[10px]">{{ activeNotifications.length }}</span>
              </button>
              <button @click="notifTab = 'completed'"
                class="flex-1 text-xs font-medium py-2 text-center transition-colors"
                :class="notifTab === 'completed' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'">
                Completed <span v-if="completedNotifications.length" class="ml-1 bg-gray-100 text-gray-600 rounded-full px-1.5 py-0.5 text-[10px]">{{ completedNotifications.length }}</span>
              </button>
            </div>
            <div class="flex-1 overflow-y-auto">
              <div v-if="displayedNotifications.length === 0" class="px-4 py-8 text-center text-sm text-gray-400">
                {{ notifTab === 'active' ? 'No active notifications' : 'No completed notifications' }}
              </div>
              <div v-for="(n, idx) in displayedNotifications" :key="idx"
                class="px-3 py-2.5 border-b flex items-start gap-2 group"
                :class="[
                  isHighPriority(n) ? 'bg-red-50 border-red-100' : 'border-gray-50',
                ]">
                <!-- Checkbox -->
                <button @click.stop="toggleNotificationDone(n)"
                  class="w-5 h-5 mt-0.5 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors"
                  :class="n.read ? 'bg-green-500 border-green-500' : 'border-gray-300 hover:border-gray-400 bg-white'">
                  <i v-if="n.read" class="fa-solid fa-check text-white" style="font-size:10px"></i>
                </button>
                <!-- Content (clickable to scroll to job) -->
                <div class="flex-1 min-w-0 cursor-pointer" @click="goToNotificationJob(n)">
                  <div class="flex items-center mb-0.5">
                    <span class="w-1.5 h-1.5 rounded-full mr-1.5 flex-shrink-0" :class="dotColor(n)"></span>
                    <span class="text-sm font-medium truncate" :class="[isHighPriority(n) ? 'text-red-800' : 'text-gray-800', n.read ? 'line-through text-gray-400' : '']">
                      {{ notificationTitle(n) }}
                    </span>
                    <span v-if="isHighPriority(n)" class="ml-1 text-[8px] font-medium bg-red-100 text-red-600 px-1 py-px rounded-full flex-shrink-0 leading-tight">
                      {{ highPriorityLabel(n) }}
                    </span>
                    <span class="ml-auto text-[10px] text-gray-400 flex-shrink-0 group-hover:hidden">{{ formatTimeAgo(n.timestamp) }}</span>
                    <button @click.stop="removeNotification(n)" class="ml-auto hidden group-hover:flex w-5 h-5 items-center justify-center rounded text-gray-300 hover:text-red-500 hover:bg-red-50 transition-colors flex-shrink-0">
                      <i class="fa-solid fa-xmark text-xs"></i>
                    </button>
                  </div>
                  <div class="text-xs ml-3" :class="[isHighPriority(n) ? 'text-red-700' : 'text-gray-600', n.read ? 'text-gray-400' : '']">{{ n.body || n.company }}</div>
                  <div v-if="!n.body && n.projectName" class="text-xs text-gray-400 ml-3">{{ n.projectName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Click-away for notifications -->
        <div v-if="showNotifications" class="fixed inset-0" style="z-index: 9998" @click="showNotifications = false"></div>

        <!-- User / Logout -->
        <button @click="logout()"
          class="h-8 w-8 rounded-md flex items-center justify-center text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors">
          <i class="fa-solid fa-arrow-right-from-bracket text-sm"></i>
        </button>
      </div>
    </div>


    <!-- CRM Reminder Popup (shows on any page for today's reminders) -->
    <div v-if="showCrmReminderPopup && crmTodaysReminders.length" class="fixed inset-0 z-50 flex items-end sm:items-center justify-center" style="z-index: 999999">
      <div class="absolute inset-0 bg-black bg-opacity-40" @click="dismissCrmReminders"></div>
      <div class="relative bg-white w-full sm:max-w-md sm:rounded-2xl shadow-2xl overflow-hidden z-10">
        <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-yellow-50">
          <div class="flex items-center gap-2">
            <i class="fa-solid fa-bell text-yellow-500 text-lg"></i>
            <div>
              <h2 class="text-base font-bold text-gray-900">CRM Reminders</h2>
              <p class="text-xs text-gray-500 mt-0.5">{{ crmTodaysReminders.length }} reminder{{ crmTodaysReminders.length > 1 ? 's' : '' }} due today or overdue</p>
            </div>
          </div>
          <button @click="dismissCrmReminders" class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-200">
            <i class="fa-solid fa-xmark text-lg"></i>
          </button>
        </div>
        <div class="px-5 py-4 space-y-3 max-h-72 overflow-y-auto">
          <div v-for="rem in crmTodaysReminders" :key="rem.id" class="flex items-start gap-3 bg-yellow-50 rounded-lg p-3 border border-yellow-200">
            <i class="fa-solid fa-clock text-yellow-500 mt-0.5"></i>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-gray-900">{{ rem.subject }}</p>
              <p class="text-xs text-gray-500 mt-0.5">{{ rem.leadName || (rem.lead ? rem.lead.contact : '') }}</p>
              <p class="text-[10px] text-gray-400 mt-0.5">{{ rem.date }}</p>
            </div>
          </div>
        </div>
        <div class="px-5 py-3 border-t border-gray-200 bg-gray-50 flex gap-2">
          <button @click="goToCrm" class="flex-1 h-10 rounded-lg text-sm font-semibold bg-primary text-white hover:opacity-90 transition-colors">Open CRM</button>
          <button @click="dismissCrmReminders" class="px-4 h-10 rounded-lg text-sm font-medium bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">Dismiss</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {signMeOut, getCrmReminders} from "../../firestore/utils"
import { collection, query, where, orderBy, limit, onSnapshot, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";
export default {
    data() {
        return {
            openDropdown: null,
            showNotifications: false,
            notifTab: 'active',
            showMobileMenu: false,
            mobileSection: null,
            firestoreNotifications: [],
            unsubNotifications: null,
            showCrmReminderPopup: false,
            crmTodaysReminders: [],
            crmRemindersDismissed: false,
        }
    },
    computed:{
        currentUser(){
            return this.$store.state.currentUser
        },
        notifications() {
            const vuex = this.$store.state.clientNotifications || [];
            const fs = this.firestoreNotifications || [];
            return [...vuex, ...fs].sort((a, b) => {
              const ap = this.isHighPriority(a) ? 1 : 0;
              const bp = this.isHighPriority(b) ? 1 : 0;
              if (ap !== bp) return bp - ap;
              return (b.timestamp || 0) - (a.timestamp || 0);
            }).slice(0, 50);
        },
        unreadCount() {
            return this.notifications.filter(n => !n.read).length;
        },
        activeNotifications() {
            return this.notifications.filter(n => !n.read);
        },
        completedNotifications() {
            return this.notifications.filter(n => n.read);
        },
        displayedNotifications() {
            return this.notifTab === 'active' ? this.activeNotifications : this.completedNotifications;
        },
    },
    methods:{
      isRoute(name) {
        return this.$route.name === name;
      },
      isRouteGroup(names) {
        return names.includes(this.$route.name);
      },
      openAiAssistant(){
        this.$root.$emit('open-chat-widget')
      },
      dotColor(n) {
        if (this.isHighPriority(n)) return 'bg-red-500';
        if (n.status === 'FIRM' || n.type === 'new_job_request') return 'bg-green-500';
        if (n.status === 'CHANGED' || n.type === 'job_changed' || n.type === 'question') return 'bg-yellow-500';
        if (n.status === 'CANCELLED' || n.type === 'job_cancelled' || n.type === 'complaint') return 'bg-red-500';
        return 'bg-gray-400';
      },
      isHighPriority(n) {
        if (n.jobIds && n.jobIds.length > 1) return true;
        if (n.id && !n.jobId && (!n.jobIds || n.jobIds.length === 0)) return true;
        return false;
      },
      highPriorityLabel(n) {
        if (n.jobIds && n.jobIds.length > 1) return 'multiple jobs';
        return 'no job attached';
      },
      notificationTitle(n) {
        if (n.title) return n.title;
        if (n.status === 'FIRM') return 'Confirmed';
        if (n.status === 'CHANGED') return 'Change Requested';
        if (n.status === 'CANCELLED') return 'Cancelled';
        return 'Notification';
      },
      toggleNotificationDone(n) {
        const newRead = !n.read;
        if (n.id) {
          updateDoc(doc(db, "notifications", n.id), { read: newRead });
        } else {
          this.$set(n, 'read', newRead);
        }
      },
      goToNotificationJob(n) {
        const jobId = n.jobId || (n.jobIds && n.jobIds.length > 0 ? n.jobIds[0] : null);
        if (jobId) {
          this.$root.$emit('scroll-to-job', jobId);
        }
      },
      removeNotification(n) {
        if (n.id) {
          deleteDoc(doc(db, "notifications", n.id));
        } else {
          const vuex = this.$store.state.clientNotifications || [];
          const vuexIdx = vuex.indexOf(n);
          if (vuexIdx !== -1) this.$store.commit('removeClientNotification', vuexIdx);
        }
      },
      clearAllNotifications() {
        this.$store.commit('clearClientNotifications');
        for (const n of this.firestoreNotifications) {
          if (n.id) {
            deleteDoc(doc(db, "notifications", n.id));
          }
        }
      },
      formatTimeAgo(ts) {
        if (!ts) return '';
        const diff = Math.floor((Date.now() - ts) / 1000);
        if (diff < 60) return 'just now';
        if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
        if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
        return Math.floor(diff / 86400) + 'd ago';
      },
      mobileNavigate(route) {
        this.showMobileMenu = false;
        this.mobileSection = null;
        this.$router.push(route);
      },
      async logout(){
        this.showMobileMenu = false;
        await signMeOut()
        this.$router.push({name: 'Login'})
      },
      dismissCrmReminders() {
        this.showCrmReminderPopup = false;
        this.crmRemindersDismissed = true;
      },
      goToCrm() {
        this.showCrmReminderPopup = false;
        this.crmRemindersDismissed = true;
        this.$router.push({ name: 'Crm' });
      },
      async checkCrmReminders() {
        if (this.crmRemindersDismissed || !this.currentUser) return;
        // Only surface the reminder popup once per calendar day, per user
        const shownKey = `crmRemindersShown:${this.currentUser.id}`;
        const todayKey = this.$moment().format('YYYY-MM-DD');
        if (localStorage.getItem(shownKey) === todayKey) {
          this.crmRemindersDismissed = true;
          return;
        }
        try {
          const allReminders = await getCrmReminders();
          const today = new Date();
          const todayStr = today.toISOString().split('T')[0];
          const userId = this.currentUser.id;
          this.crmTodaysReminders = allReminders.filter(r => {
            const rDateRaw = r.date;
            let rDate = '';
            if (rDateRaw) {
              if (rDateRaw.seconds) rDate = new Date(rDateRaw.seconds * 1000).toISOString().split('T')[0];
              else if (typeof rDateRaw === 'string') rDate = rDateRaw.split('T')[0];
              else if (rDateRaw instanceof Date) rDate = rDateRaw.toISOString().split('T')[0];
            }
            const isForUser = (r.createdBy && r.createdBy.id === userId) ||
                              (r.assignedTo && r.assignedTo.id === userId) ||
                              (!r.createdBy && !r.assignedTo);
            return isForUser && rDate <= todayStr && !r.dismissed;
          });
          if (this.crmTodaysReminders.length > 0) {
            this.showCrmReminderPopup = true;
            localStorage.setItem(shownKey, todayKey);
          }
        } catch (e) { console.error('CRM reminder check error:', e); }
      },
    },
    created() {
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      const q = query(
        collection(db, "notifications"),
        where("created", ">=", sevenDaysAgo),
        orderBy("created", "desc"),
        limit(50)
      );
      this.unsubNotifications = onSnapshot(q, (snap) => {
        this.firestoreNotifications = snap.docs.map(d => ({
          id: d.id, ...d.data(),
          timestamp: d.data().created?.toMillis?.() || Date.now(),
        }));
      });
      // Check CRM reminders after a short delay to let auth settle
      setTimeout(() => this.checkCrmReminders(), 2000);
    },
    beforeDestroy() {
      if (this.unsubNotifications) this.unsubNotifications();
    },
}
</script>

<style scoped>
.nav-item {
  height: 40px;
  padding: 0 14px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  white-space: nowrap;
  transition: all 0.15s;
}
.nav-active {
  background: #f3f4f6;
  color: #111827;
}
.nav-default {
  color: #4b5563;
}
.nav-default:hover {
  color: #111827;
  background: #f9fafb;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  padding-top: 6px;
  z-index: 50;
}
.dropdown-menu-inner {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  border: 1px solid #e5e7eb;
  padding: 4px 0;
  min-width: 200px;
}
.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  font-size: 15px;
  font-weight: 500;
  color: #374151;
  transition: background 0.15s;
}
.dropdown-item:hover {
  background: #f9fafb;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s;
}
.slide-enter-active > div:last-child,
.slide-leave-active > div:last-child {
  transition: transform 0.3s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.slide-enter > div:last-child,
.slide-leave-to > div:last-child {
  transform: translateX(100%);
}
</style>
